(function () {
  if (window.__fpbInit) return;
  window.__fpbInit = true;

  var SHOW_MS = 8000;
  var FADE_MS = 500;

  var cols = ['#FF6FAE', '#FF8FC0', '#FFC9E0', '#B9A4F2', '#FFE680', '#9FE8C9', '#8FD3FF', '#FFB48A'];
  var radii = ['2px', '50%', '2px', '0'];

  function unlocked() {
    var el = document.querySelector('[data-fpb]');
    return el ? el.getAttribute('data-unlocked') === 'true' : null;
  }

  var prev = unlocked() === true;

  function piece(box, sx, sy, dx, dy, delay) {
    var d = document.createElement('div');
    var w = 8 + Math.random() * 9;
    var h = 9 + Math.random() * 11;
    var star = Math.random() > 0.8;
    d.style.cssText =
      'position:absolute;left:' + sx + 'px;top:' + sy + 'px;width:' + w + 'px;height:' + h + 'px;' +
      'background:' + cols[Math.floor(Math.random() * cols.length)] + ';' +
      'border:1.5px solid #000;border-radius:' + radii[Math.floor(Math.random() * 4)];
    if (star) {
      var s = 14 + Math.random() * 8;
      d.style.width = s + 'px';
      d.style.height = s + 'px';
      d.style.border = 'none';
      d.style.background = '#FFE680';
      d.style.clipPath = 'polygon(50% 0,62% 38%,100% 50%,62% 62%,50% 100%,38% 62%,0 50%,38% 38%)';
    }
    box.appendChild(d);
    var r = (Math.random() - 0.5) * 1080;
    var anim = d.animate(
      [
        { transform: 'translate(0,0) rotate(0deg)', opacity: 1 },
        { transform: 'translate(' + dx * 0.7 + 'px,' + dy + 'px) rotate(' + r * 0.5 + 'deg)', opacity: 1, offset: 0.45 },
        { transform: 'translate(' + dx + 'px,' + (dy + 300 + Math.random() * 80) + 'px) rotate(' + r + 'deg)', opacity: 0 }
      ],
      { duration: 2100 + Math.random() * 900, delay: delay, easing: 'cubic-bezier(.15,.7,.35,1)', fill: 'backwards' }
    );
    anim.onfinish = function () { d.remove(); };
  }

  function showBanner(dlg) {
    var tpl = document.querySelector('template[data-fpb-banner]');
    if (!tpl || !dlg) return;
    var wrap = document.createElement('div');
    wrap.className = 'fpb-overlay';
    wrap.appendChild(tpl.content.cloneNode(true));
    dlg.appendChild(wrap);
    setTimeout(function () { wrap.classList.add('fpb-out'); }, SHOW_MS - FADE_MS);
    setTimeout(function () { wrap.remove(); }, SHOW_MS);
    dlg.addEventListener('close', function () { wrap.remove(); }, { once: true });
  }

  function confetti(host) {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var box = document.createElement('div');
    box.style.cssText = 'position:fixed;top:0;right:0;bottom:0;left:0;overflow:hidden;pointer-events:none;z-index:2147483000';
    host.appendChild(box);
    var W = window.innerWidth;
    var H = window.innerHeight;
    var i;
    for (i = 0; i < 50; i++) piece(box, W / 2, H * 0.3, (Math.random() - 0.5) * W * 1.1, -60 - Math.random() * 130, Math.random() * 150);
    for (i = 0; i < 45; i++) piece(box, 0, H, Math.random() * W * 0.9, -H * 0.5 - Math.random() * H * 0.5, 150 + Math.random() * 250);
    for (i = 0; i < 45; i++) piece(box, W, H, -Math.random() * W * 0.9, -H * 0.5 - Math.random() * H * 0.5, 150 + Math.random() * 250);
    setTimeout(function () { box.remove(); }, 4800);
    host.addEventListener('close', function () { box.remove(); }, { once: true });
  }

  function celebrate() {
    var dlg = document.querySelector('#cart-drawer dialog[open]');
    showBanner(dlg);
    confetti(dlg || document.body);
  }

  new MutationObserver(function () {
    var now = unlocked();
    if (now === null) return;
    if (!prev && now) celebrate();
    prev = now;
  }).observe(document.body, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ['data-unlocked']
  });
})();